import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { CostType, PagedResponseCostType } from '../models/CostType';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class CostTypeService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getCostTypes():Observable<PagedResponseCostType>{
    const data =  this.http.get<PagedResponseCostType>(this.APIURL+'/CostType' + '?PageNumber=1&PageSize=50');
    this.messageService.add('CostType Service: fetched shops');
    return data;
  }

  getCostType(id: number): Observable<CostType> {
        const CostType =this.http.get<CostType>(this.APIURL+'/CostType/' + id);
    this.messageService.add(`CostType Service: fetched CostType with id=${id}`);
    return CostType;
  }
}